import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useNotificationListListener } from "./useBaseNotificationListener";
import { injectNotificationDocument } from "./injectNotificationDocument";
import { initialNotificationsFetch } from "../reducer";
import { DocReference, Query } from "../../../types/firebase.types";

export const useBaseNotificationSubscription = (props: {
  canReceiveNotification: boolean;
  query: Query;
  unseenQuery: DocReference;
  canPlaySound: (data: any) => boolean;
  userData?: Record<string, any>;
  onClick?: (...args: any[]) => void;
}) => {
  const { canReceiveNotification = false, query, unseenQuery, userData = {}, onClick } = props;

  const dispatch = useDispatch();
  const [notificationCounter, setNotificationCounter] = useState(0);

  useNotificationListListener({
    query,
    canGetNotifications: canReceiveNotification,
    prepareNotifications: injectNotificationDocument,
    notificationCounter,
    playSound: (data) => {
      return !data.seenBy.length;
    },
    userData,
    onClick,
  });

  useEffect(() => {
    /**
     * make sure to register the notification saga in the main app saga config
     * */
    if (canReceiveNotification) dispatch(initialNotificationsFetch({ query }));
  }, [canReceiveNotification]);

  useEffect(() => {
    let unsub: any;

    if (canReceiveNotification)
      unsub = unseenQuery.onSnapshot((snapshot) => {
        if (snapshot.exists) {
          const data = snapshot.data();
          if (data) setNotificationCounter(data.unseenNotifications);
        }
      });

    return () => {
      unsub?.();
    };
  }, [canReceiveNotification]);
};
